import React from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { PlayerSelectionModal } from "./PlayerSelectionModal";
import { getPlayerTypeIcon } from "../util/player-utils";
import Box from "@mui/material/Box";
import { PlayerName } from "./FormatPlayers";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {import("@seabrookstudios/pitch2table-core").PlayTestPlayer} props.player
 * @param {function} props.onPlayerUpdate - Function to update the entire player object
 * @param {import("@seabrookstudios/pitch2table-core").PlayTestPlayer[]} [props.allPlayers] - All players to determine counts
 */
export const PlayerNameField = ({ gameId, player, onPlayerUpdate, allPlayers = [] }) => {
  return (
    <PlayerSelectionModal gameId={gameId} player={player} onPlayerUpdate={onPlayerUpdate} allPlayers={allPlayers}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Button
          variant="text"
          size="small"
          sx={{
            textTransform: "none",
            justifyContent: "flex-start",
            alignItems: "center",
            color: "text.primary",
          }}
        >
          {getPlayerTypeIcon(player)}
          <Box p={1} />
          <PlayerName player={player} />
        </Button>
      </Stack>
    </PlayerSelectionModal>
  );
};
